/**
 * Shared validation utility for vendor and PO search inputs.
 */

interface ValidationResult {
  isValid: boolean;
  error: string | null;
  sanitized: string;
}

/**
 * Validates and sanitizes a search term before sending to the backend.
 * Sanitization happens first so length checks apply to the cleaned value.
 */
export const validateSearchTerm = (term: string | null | undefined): ValidationResult => {
  if (term == null) {
    return { isValid: false, error: 'Please enter at least 2 characters to search.', sanitized: '' };
  }
  const sanitized = term.trim().replace(/[<>"'&`]/g, '');

  if (!sanitized || sanitized.length < 2) {
    return { isValid: false, error: 'Please enter at least 2 characters to search.', sanitized };
  }
  if (sanitized.length > 100) {
    return { isValid: false, error: 'Search term too long (max 100 characters).', sanitized };
  }

  return { isValid: true, error: null, sanitized };
};
